module.exports = "/static/assets/eca17c99b2f66a20a4f0c25048bfc108.png";